import {
  ROOT_EQUIPMENT_STATUS_MAP,
  RootEquipmentStatus,
  SiteGroup,
} from "@abb-connect/react-shared";
import { RootEquipmentStatusResult } from "@models/root-equipment-status-result";

export const assignStatusToHierarchy = (
  hierarchy?: SiteGroup[],
  status?: RootEquipmentStatusResult[]
) => {
  if (!hierarchy) {
    return [];
  }
  if (!status || status.length === 0) {
    return hierarchy;
  }

  return hierarchy.map((group) => ({
    ...group,
    plants: group.plants.map((plant) => ({
      ...plant,
      rootEquipment: plant.rootEquipment.map((rootEquipment) => ({
        ...rootEquipment,
        status:
          status.find(
            (s) => s.clientId === `${plant.name}.${rootEquipment.name}`
          )?.dataPoints[0].value ?? RootEquipmentStatus.NoDataConnection,
      })),
    })),
  }));
};

export const countByStatus = (statusList: RootEquipmentStatus[]): number[] => {
  return statusList.reduce((acc, status) => {
    acc[status + 1] = acc[status + 1] + 1;
    return acc;
  }, Array<number>(ROOT_EQUIPMENT_STATUS_MAP.size).fill(0));
};
